import Head from "next/head";
import dynamic from "next/dynamic";

const FaqPage = dynamic(() => import("../js/Components/FAQ/FAQ"));

//Dynamically load the home component and return it
const faq = ({ data }) => {
    return (
        <>
            <Head>
                <title>{`Frequently Asked Questions - ${process.env.brand.brand_name}`}</title>
                <meta
                    name="description"
                    content={`Frequently Asked Questions about hiring furniture from ${process.env.brand.brand_name}`}
                />
            </Head>
            <FaqPage {...data}/> 
        </>
    );
};

export async function getStaticProps({ query, res }) {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}faq`);
        const data = await req.json()

        if(data.exception) {
            return {notFound: true}
        }
    
        return {
            props: {
                data
             },
        };
        
    } catch (error) {
        return {notFound: true} //404
    }
}

export default faq;
